import { render } from "./Cumpleanios.vue?vue&type=template&id=6cd86ec6&scoped=true"
import script from "./Cumpleanios.vue?vue&type=script&lang=js"
export * from "./Cumpleanios.vue?vue&type=script&lang=js"

import "./Cumpleanios.vue?vue&type=style&index=0&id=6cd86ec6&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd86ec6"]])

export default __exports__